import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';

const Container = styled.div`
  // background: rgba(0,0,0,0.3);
  // background: black;
`
  
const ContentContainer = styled.div`
  padding: 10px 10px;
  border-radius: 10px;
`

const Header = styled.div`
  // background: rgba(0,0,0,0.3);
  // color: white;
  margin-bottom: 6px;
  font-weight: 600;
`
const Optional = styled.span`
  color: rgba(0,0,0,0.26);
  display: inline-block;
  margin-left: 4px;
  font-size: 90%;
`;
const SmallerIcon = styled(Icon)`
  font-size: 18px;
`;

const HeaderWrapper = ({
  header,
  children,
  className,
  optional,
  tooltipTitle,
  ...other
}) => {
  /*
  if (optional) {
    header = [header, <Optional>(optional)</Optional>];
  }
  if (tooltipTitle) {
    header = [
      header,
      <Tooltip title={tooltipTitle} placement="right">
        <SmallerIcon>info</SmallerIcon>
      </Tooltip>
    ];
  }
  */
  return (
    <Container {...other}>
      {header && (
        <Header>
          {header}
          {optional && <Optional>(optional)</Optional>}
          {tooltipTitle && (
            <Tooltip title={tooltipTitle} placement="right">
              <SmallerIcon>info</SmallerIcon>
            </Tooltip>
          )}
        </Header>
      )}
      <ContentContainer className={className}>
        {children}
      </ContentContainer>
    </Container>
  )
}

HeaderWrapper.propTypes = {
  header: PropTypes.string,
};

HeaderWrapper.defaultProps = {

};

export default HeaderWrapper;
